import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../config';

const API = API_BASE_URL;

export default function PendingSurveys() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchPending(); }, []);

  async function fetchPending() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/surveys/pending`, { credentials: 'include' });
      if (!r.ok) throw new Error('failed');
      const j = await r.json();
      setPending(j.pending || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }

  async function submit(id, template, answers) {
    try {
      // normalize answers: ensure every question id from template is present
      const bodyAnswers = Object.assign({}, answers || {});
      if (template && Array.isArray(template.questions)) {
        for (const q of template.questions) {
          if (!Object.prototype.hasOwnProperty.call(bodyAnswers, q.id)) {
            if (q.type === 'checkbox') bodyAnswers[q.id] = [];
            else if (q.type === 'number') bodyAnswers[q.id] = 0;
            else bodyAnswers[q.id] = '';
          }
        }
      }
      const body = { answers: bodyAnswers };
      console.log('Submitting survey payload', body);
      const r = await fetch(`${API}/api/surveys/response/${id}`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json();
      if (!j.ok) return alert('submit failed');
      alert('Gönderildi');
      fetchPending();
    } catch (e) { console.error(e); alert('hata'); }
  }

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Bekleyen Anketler</h2>
      {loading ? <div>Yükleniyor...</div> : (
        <div className="space-y-4">
          {pending.length === 0 ? <div>Bekleyen anket yok.</div> : pending.map(p => (
            <SurveyCard key={p.id} p={p} onSubmit={(answers) => submit(p.id, p.template, answers)} />
          ))}
        </div>
      )}
    </div>
  );
}

function SurveyCard({ p, onSubmit }) {
  const tpl = p.template;
  const [answers, setAnswers] = useState({});

  function toggleOption(qid, option) {
    const cur = answers[qid] || [];
    if (cur.includes(option)) setAnswers(a => ({ ...a, [qid]: cur.filter(x=>x!==option) }));
    else setAnswers(a => ({ ...a, [qid]: [...cur, option] }));
  }

  function setDropdown(qid, val) {
    setAnswers(a => ({ ...a, [qid]: val }));
  }

  return (
    <div className="border rounded p-4 bg-white">
      <div className="font-semibold mb-2">{tpl.title} <span className="text-xs text-gray-500">v{tpl.version}</span></div>
      {Array.isArray(tpl.questions) ? tpl.questions.map((q, i) => (
        <div key={i} className="mb-3">
          <div className="text-sm font-medium mb-1">{q.label}</div>
          {q.type === 'checkbox' ? (
            <div className="flex flex-wrap gap-2">
              {Array.isArray(q.options) ? q.options.map(opt => (
                <label key={opt} className="px-3 py-1 border rounded cursor-pointer"><input type="checkbox" className="mr-2" checked={(answers[q.id]||[]).includes(opt)} onChange={()=>toggleOption(q.id,opt)} />{opt}</label>
              )) : null}
            </div>
          ) : (
            <select value={answers[q.id]||''} onChange={e=>setDropdown(q.id, e.target.value)} className="p-2 border rounded w-full">
              <option value="">Seçiniz</option>
              {Array.isArray(q.options) ? q.options.map(opt => <option key={opt} value={opt}>{opt}</option>) : null}
            </select>
          )}
        </div>
      )) : <div>Şablon soruları okunamadı.</div>}

      <div className="flex gap-2">
        <button onClick={()=>onSubmit(answers)} className="px-4 py-2 bg-primary text-white rounded">Gönder</button>
      </div>
    </div>
  );
}
